<template lang="html">
  <div class="uploader">
    <el-upload
      :action="uploadUrl"
      :headers="headers"
      :data="data"
      :on-preview="handlePreview"
      :before-remove="handleBeforeRemove"
      :on-error="handleError"
      :before-upload="handleBeforeUpload"
      :on-success="handleSuccess"
      :on-remove="handleRemove"
      :on-exceed="handleExceed"
      :list-type="listType"
      :file-list="fileList"
      :limit="limit"
      :multiple="multiple"
    >
      <template>
        <el-button size="mini"
          plain
          round
          type="primary"
          icon="el-icon-upload2"
        >
          {{text}}
        </el-button>
        <div slot="tip" class="el-upload__tip">
          {{tip}}
        </div>
      </template>
    </el-upload>
  </div>
</template>

<script>
  import { Message } from 'element-ui'
  // import { MessageBox } from 'element-ui'
  import store from '../store/index'
  import router from '../router'
  import Vue from 'vue'
  import ApiSetting from '@/request/api/setting'
  export default {
    props: {
      showSlug: String,
      fileType: String,
      text: String,
      tip: String,
      listType: String,  // picture / picture-card / text(default)
      multiple: Boolean,
      idList: {
        type: Array,
        default: function () {
          return []
        }
      },
      limit: {
        type: Number,
        default: 1
      },
      sizeLimit: {
        type: Number,
        default: 0
      },
      allowedTypes: {
        type: Array,
        default: function() {
          return []
        }
      }
    },
    watch: {
      fileType (newVal, oldVal) {
        window.console.log("FILE TYPE的值是：")
        window.console.log(newVal)
        window.console.log(oldVal)
      },
      idList (newVal, oldVal) {
        let changed = newVal.toString() != oldVal.toString()
        if (newVal && changed) {
          window.console.log("idList产生新变化")
          window.console.log(newVal, oldVal)
          this.getFiles(this.idList)
          // this.getToken()
        }
      }
    },
    data () {
      return {
        // uploadUrl: '/api/media/',
        // uploadUrl: 'https://natang-api.lengqidong.com/api/media/',
        fileList: [],
        headers: {
          Authorization: 'JWT' + ' '
        },
        data: {
          show_slug: this.showSlug
        }
      }
    },
    computed: {
      uploadUrl () {
        // let url
        // if (process.env.NODE_ENV == 'development') {
        //   url = '/api/media/'
        // } else {
        //   url = 'https://natang-api.lengqidong.com/api/media/'
        // }
        // return url
        return ApiSetting.baseUrl + '/api/media/'
      }
    },
    methods: {
      getToken () {
        let token = store.state.token
        if (token == null) {
          token = Vue.localStorage.get('token', null)
          store.commit('setToken', token)
        }
        this.headers.Authorization = 'JWT ' + token
      },
      getFiles (ids) {
        let that = this
        //if (that.listType == 'picture') {
        if (that.fileType == 'Image') {
          if (ids) {
            that.fileList = []
            for (let i = 0; i < ids.length; i++) {
              if (ids[i]) {
                that.$api.image.detail(ids[i]).then(res => {
                  window.console.log(res)
                  let file = {
                    name: `${res.data.filename}.${res.data.extension}`,
                    url: res.data.private_cdns[0].cdn_url,
                    id: res.data.id
                  }
                  let newFileList = that.fileList
                  newFileList.push(file)
                  that.fileList = newFileList
                })
              }
            }
          }
        } else if (that.fileType == 'Audio') {
          window.console.log("音频文件...")
          if (ids) {
            that.fileList = []
            for (let i = 0; i < ids.length; i++) {
              if (ids[i]) {
                that.$api.audio.detail(ids[i]).then(res => {
                  window.console.log("获取到音频文件：")
                  window.console.log(res)
                  let file = {
                    name: `${res.data.filename}.${res.data.extension}`,
                    url: res.data.private_cdns[0].cdn_url,
                    id: res.data.id
                  }
                  let newFileList = that.fileList
                  newFileList.push(file)
                  that.fileList = newFileList
                })
              }
            }
          }
        }
      },
      handleBeforeUpload (file) {
        window.console.log("准备开始上传...")
        window.console.log(file)
        let sizeLimit = this.sizeLimit
        let allowedTypes = this.allowedTypes
        let overSize = file.size > sizeLimit
        let wrongType = allowedTypes.indexOf(file.type) == -1
        if (overSize || wrongType) {
          let message = ''
          if (overSize) {
            message += `文件大小不得超过${sizeLimit / (1024 * 1024)}M `
          }
          if (wrongType) {
            message += `允许上传的文件类型为：${allowedTypes} `
          }
          Message.error({
            message: message
          })
          return false
        }
      },
      handleBeforeRemove(file, fileList) {
        window.console.log("准备删除...")
        window.console.log(file)
        window.console.log(fileList)
        // let result = new Promise(function(resolve, reject) {
        //   MessageBox.confirm(
        //     '此操作将永久删除该文件, 是否继续?',
        //     '删除确认',
        //     {
        //       type: 'warning'
        //     }).then(() => {
        //       resolve()
        //     }).catch(() => {
        //       reject()
        //     })
        // })
        // return result
      },
      handleError(err, file, fileList) {
        window.console.log(file)
        window.console.log(fileList)
        window.console.log(err.name)
        window.console.log(err.message)
        let error = JSON.parse(err.message)
        window.console.log(error)
        if (error.detail == 'Error decoding signature.') {
          Message.error({
            message: `需要登录后才能操作`
          })
        } else {
          Message.error({
            message: `文件上传失败，请重试`
          })
        }
        Vue.localStorage.set('redirect', router.currentRoute.fullPath)
        router.replace({path: '/account/login/'})
      },
      handleSuccess(response, file, fileList) {
        window.console.log(response)
        window.console.log(file)
        window.console.log(fileList)
        this.$emit(
          'upload-success',
          {
            fileId: response.id,
            fileName: `${response.filename}.${response.extension}`
          }
        )
        Message.success({
          message: `文件上传成功`
        })
      },
      handleRemove(file, fileList) {
        let that = this
        window.console.log("删除文件:")
        window.console.log(file, fileList)
        // 删除对应的本地文件和云端文件
        let classname
        if (that.fileType == 'Image') {
          classname = 'Image'
        } else if (that.fileType == 'Audio') {
          classname = 'Audio'
        }
        let params = {
          classname: classname,
          objectid: file.id
        }
        that.$api.media.delete(params)
        that.$emit('file-removed', { fileName: file.name })
      },
      handlePreview(file) {
        window.console.log(file);
      },
      handleExceed(files, fileList) {
        Message.error({
          message: `只能上传 ${this.limit} 个文件`
        })
        window.console.log("超出文件数量限制")
        window.console.log(files)
        window.console.log(fileList)
      }
    },
    mounted () {
      this.getFiles(this.idList)
      this.getToken()
    }
  }
</script>

<style lang="css" scoped>
  .uploader {
    text-align: center;
    /* background: #f4f4f5; */
    background: #f5f7fa;
    padding: 10px;
    border-radius: 4px;
  }
</style>
